import Link from "next/link";
import React from "react";
import ImageCompanyLogo from "../ImageCompanyLogo";

export default function CompanyCard(props) {
  const company = props.company;
  const type = props.type;
  const membersCountObj = props.membersCount;
  const membersCount = membersCountObj[company.organizationId];

  const slug = type === "stacks" ? "stacks" : "company";
  return (
    <div
      style={{ cursor: "pointer" }}
      className="d-flex pointer flex-row gap-3 align-items-center justify-content-start"
    >
      <ImageCompanyLogo
        width={40}
        height={40}
        className="rounded-circle"
        company={company}
      />
      <Link cursor="pointer" href={`/${slug}/${company.slug}`}>
        <div className="d-flex flex-column">
          <p className="m-0 text-capitalize">{company.companyName}</p>
          <p className="text-muted m-0">
            {membersCount} {membersCount > 1 ? "members" : "member"}
          </p>
        </div>
      </Link>
    </div>
  );
}
